<template>
    <div class="adduser" style="min-height:85vh;overflow-x: hidden;position: relative;">
        <div v-if="isLoading" style="position: absolute;left: 50%;z-index: 3;margin-left:-50px;display: inline-flex;text-align: center;top:190px;border-radius: 4px;">
            <LoadingBar />
        </div>
        <div style="display:flex">
            <div style="margin: 16px 0;display:flex">
                <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                    <a-breadcrumb-item style="font-size:30px;">Hotels</a-breadcrumb-item>
                </a-breadcrumb>
                <a-button style="margin-top:auto;margin-bottom:auto;margin-left:20px" type="primary">
                    <router-link to="/admin/addhotel">
                    Add Hotel
                    </router-link>
                </a-button>
            </div>
        </div>
        
        <div style="position:relative">
          <div style="position:absolute;right:0;top:-30px;display:flex;">
            <a-input-search style="width:400px;margin-right:0px;margin-left:auto" v-model="hotelSearchText" placeholder="" @search="onSearch">
              <a-button slot="enterButton">
                Search Hotel
              </a-button>
            </a-input-search>
          </div>
          <div style="display:flex">
              <a-tabs
                  :active-key="currentTab"
                  :tab-position="'top'"
                  @change="handleTabChange"
              >
                  <a-tab-pane key="all" tab="All">
                      <HotelsTableItem
                        :key="listState.all.pagination.pageSize"
                        :hotellist="listState.all.list"
                        :columns="columns"
                        :tableCellCount="listState.all.pagination.pageSize"
                        :pagination="listState.all.pagination"
                        :loading="isLoading && currentTab === 'all'"
                        :filterDate="listState.all.filters.date"
                        :filterSeoScore="listState.all.filters.seoScore"
                        :filterReadScore="listState.all.filters.readScore"
                        @listUpdate="() => listUpdate('all')"
                        @listFilter="filters => listFilter('all', filters)"
                        @listFilterCount="count => listFilterCount('all', count)"
                        @tableChange="payload => handleTableChange('all', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="mine" tab="Mine" force-render>
                      <HotelsTableItem
                        :key="listState.mine.pagination.pageSize"
                        :hotellist="listState.mine.list"
                        :columns="columns"
                        :tableCellCount="listState.mine.pagination.pageSize"
                        :pagination="listState.mine.pagination"
                        :loading="isLoading && currentTab === 'mine'"
                        :filterDate="listState.mine.filters.date"
                        :filterSeoScore="listState.mine.filters.seoScore"
                        :filterReadScore="listState.mine.filters.readScore"
                        @listUpdate="() => listUpdate('mine')"
                        @listFilter="filters => listFilter('mine', filters)"
                        @listFilterCount="count => listFilterCount('mine', count)"
                        @tableChange="payload => handleTableChange('mine', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="published" tab="Published">
                      <HotelsTableItem
                        :key="listState.published.pagination.pageSize"
                        :hotellist="listState.published.list"
                        :columns="columns"
                        :tableCellCount="listState.published.pagination.pageSize"
                        :pagination="listState.published.pagination"
                        :loading="isLoading && currentTab === 'published'"
                        :filterDate="listState.published.filters.date"
                        :filterSeoScore="listState.published.filters.seoScore"
                        :filterReadScore="listState.published.filters.readScore"
                        @listUpdate="() => listUpdate('published')"
                        @listFilter="filters => listFilter('published', filters)"
                        @listFilterCount="count => listFilterCount('published', count)"
                        @tableChange="payload => handleTableChange('published', payload)"
                      />
                  </a-tab-pane>
                  <a-tab-pane key="draft" tab="Draft">
                      <HotelsTableItem
                        :key="listState.draft.pagination.pageSize"
                        :hotellist="listState.draft.list"
                        :columns="columns"
                        :tableCellCount="listState.draft.pagination.pageSize"
                        :pagination="listState.draft.pagination"
                        :loading="isLoading && currentTab === 'draft'"
                        :filterDate="listState.draft.filters.date"
                        :filterSeoScore="listState.draft.filters.seoScore"
                        :filterReadScore="listState.draft.filters.readScore"
                        @listUpdate="() => listUpdate('draft')"
                        @listFilter="filters => listFilter('draft', filters)"
                        @listFilterCount="count => listFilterCount('draft', count)"
                        @tableChange="payload => handleTableChange('draft', payload)"
                      />
                  </a-tab-pane>
              </a-tabs>
          </div>
        </div>
    </div>
</template>
<script>
import HotelsTableItem from './TableItems/HotelsTableItem.vue'
import LoadingBar from '@/components/LoadingBar.vue';
import { api } from '../helpers/Helpers';

const columns = [
  {
    title: 'Title',
    dataIndex: 'hotelname',
    key: 'hotelname',
    sorter: true,
    scopedSlots: { customRender: 'hotelname' },
  },
  {
    title: 'Auther',
    dataIndex: 'username',
    sorter: true,
    key: 'username',
  },
  {
    title: 'Comments',
    dataIndex: 'comments',
    key: 'comments',
  },
  {
    title: 'Date',
    key: 'createdate',
    dataIndex: 'createdate',
    sorter: true,
    scopedSlots: { customRender: 'createdate' },
  },
  {
    title: 'Hidden',
    key: 'hotelHidden',
    dataIndex: 'hotelHidden',
    sorter: true,
    scopedSlots: { customRender: 'hotelHidden' },
  },
  {
    title: 'Country',
    key: 'hotelCountry',
    dataIndex: 'hotelCountry',
    sorter: true,
    scopedSlots: { customRender: 'hotelCountry' },
  },
  {
    title: 'Type',
    key: 'type',
    dataIndex: 'type',
  },
  {
    title: 'Number',
    sorter: true,
    key: 'number',
    dataIndex: 'number',
  },
  {
    title: 'Image',
    key: 'hotelimage',
    dataIndex: 'hotelimage',
    scopedSlots: { customRender: 'hotelimage' },
  },
  {
    title: 'Star',
    key: 'star',
    dataIndex: 'star',
  },
  {
    title: 'Checkin',
    key: 'checkin',
    dataIndex: 'checkin',
  },
  {
    title: 'Check Out',
    key: 'checkout',
    dataIndex: 'checkout',
  },
  {
    title: 'Rooms',
    key: 'rooms',
    dataIndex: 'rooms',
  },
  {
    title: 'Action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

const defaultFilters = () => ({
  date: 'all',
  seoScore: 'all',
  readScore: 'all',
});

const createInitialState = () => ({
  list: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  searchTerm: '',
  sortField: undefined,
  sortOrder: undefined,
  filters: defaultFilters(),
});

const STATUS_PUBLISHED = 1;
const STATUS_DRAFT = 0;
const OWNER_ID_PLACEHOLDER = 'MineUserId';

export default {
  data() {
    return {
      columns,
      currentTab: 'all',
      listState: {
        all: createInitialState(),
        mine: createInitialState(),
        published: createInitialState(),
        draft: createInitialState(),
      },
      hotelSearchText: '',
      isLoading: false,
    };
  },
  components: {
    HotelsTableItem,
    LoadingBar
  },
  
  mounted(){
      this.getHotels('all');
  },
  methods: {
    createExportData(list) {
      return list.map((hotel) => ({
        Title: hotel.hotelname || '',
        Author: hotel.username || '',
        Country: hotel.hotelCountry || '',
        Type: hotel.type || '',
        Rooms: hotel.rooms || '',
        Status: hotel.status,
      }));
    },
    mapHotelToRow(hotel, index) {
      const roomsCount = hotel && hotel.hoteldatarooms && hotel.hoteldatarooms.numberofroom != null ? hotel.hoteldatarooms.numberofroom : (hotel && hotel.number != null ? hotel.number : '');
      const createdDate = hotel.createdate ? new Date(hotel.createdate) : '';
      return {
        ...hotel,
        id: hotel._id,
        key: hotel._id || index + 1,
        hotelHidden: hotel.hotelHidden || false,
        hotelCountry: hotel.hotelCountry || hotel.selectedCountry || '',
        number: roomsCount,
        rooms: roomsCount,
        createdate: createdDate,
        comments: hotel.comments || 0,
      };
    },
    buildDateRange(dateValue) {
      if (!dateValue || dateValue === 'all') {
        return {};
      }

      const baseDate = new Date(dateValue);
      if (Number.isNaN(baseDate.getTime())) {
        return {};
      }

      const from = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
      const to = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 1);

      return {
        createdFrom: from.toISOString(),
        createdTo: to.toISOString(),
      };
    },
    async getHotels(tabKey = this.currentTab) {
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }

      this.isLoading = true;

      const params = {
        page: state.pagination.current,
        limit: state.pagination.pageSize,
      };

      if (state.searchTerm) {
        params.search = state.searchTerm;
      }

      const { date, seoScore, readScore } = state.filters || defaultFilters();
      const range = this.buildDateRange(date);
      if (range.createdFrom) {
        params.createdFrom = range.createdFrom;
      }
      if (range.createdTo) {
        params.createdTo = range.createdTo;
      }

      if (seoScore && seoScore !== 'all') {
        params.seoScore = seoScore;
      }
      if (readScore && readScore !== 'all') {
        params.readScore = readScore;
      }

      if (tabKey === 'published') {
        params.status = STATUS_PUBLISHED;
      }
      if (tabKey === 'draft') {
        params.status = STATUS_DRAFT;
      }
      if (tabKey === 'mine') {
        params.ownerId = OWNER_ID_PLACEHOLDER;
      }

      // if (state.sortField) {
      //   params.sortField = state.sortField;
        
      // }

      params.sortField = 'hotelname';
      params.sortOrder = 'ascend';

      try {
        const res = await api.getAdminHotels({ params });
        const hotels = res && Array.isArray(res.hotels) ? res.hotels : [];
        const mappedHotels = hotels.map((hotel, index) => this.mapHotelToRow(hotel, index));

        state.list = mappedHotels;
        state.pagination.total = typeof res.total === 'number' ? res.total : hotels.length;
        state.pagination.current = res && res.page ? res.page : state.pagination.current;
        state.pagination.pageSize = res && res.limit ? res.limit : state.pagination.pageSize;

        if (tabKey === this.currentTab) {
          this.currentExportData = this.createExportData(mappedHotels);
        }
      } catch (error) {
        console.error('Error fetching hotels:', error);
      } finally {
        this.isLoading = false;
      }
    },
    onSearch() {
      const state = this.listState[this.currentTab];
      if (!state) {
        return;
      }
      state.searchTerm = this.hotelSearchText.trim();
      state.pagination.current = 1;
      this.getHotels(this.currentTab);
    },
    listUpdate(tabKey) {
      this.getHotels(tabKey);
    },
    listFilterCount(tabKey, count) {
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }
      state.pagination.pageSize = count;
      state.pagination.current = 1;
      this.getHotels(tabKey);
    },
    listFilter(tabKey, filters) {
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }
      state.filters = {
        ...state.filters,
        ...filters,
      };
      state.pagination.current = 1;
      if (tabKey === this.currentTab) {
        this.hotelSearchText = state.searchTerm;
      }
      this.getHotels(tabKey);
    },
    handleTableChange(tabKey, { pagination, sorter }) {
      const state = this.listState[tabKey];
      if (!state) {
        return;
      }

      if (pagination) {
        if (pagination.current) {
          state.pagination.current = pagination.current;
        }
        if (pagination.pageSize && pagination.pageSize !== state.pagination.pageSize) {
          state.pagination.pageSize = pagination.pageSize;
        }
      }

      if (sorter) {
        if (sorter.order && sorter.field) {
          state.sortField = sorter.field;
          state.sortOrder = sorter.order;
        } else {
          state.sortField = undefined;
          state.sortOrder = undefined;
        }
      }

      this.getHotels(tabKey);
    },
    handleTabChange(key) {
      this.currentTab = key;
      const state = this.listState[key];
      if (state) {
        this.hotelSearchText = state.searchTerm || '';
        if (!state.list.length) {
          this.getHotels(key);
        }
      }
    },
  }
}
</script>